import Axios from "axios";

const bp = "/bp";

export const get_department_designation_role = async (
  success,
  params,
  signal,
  api_type
) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_department_designation_role/${api_type}/`, {
    params: params,
    signal: signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const get_priority = async (success, params, signal) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_priority`, {
    params: params,
    signal: signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const get_ticket_details = async (success, params, signal) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_ticket_details`, {
    params: params,
    signal: signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const get_supervisor_approvals = async (success, params, signal) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_supervisor_approvals`, {
    params: params,
    signal: signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const get_allowed_actions = async (success, params, signal) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_allowed_actions`, {
    params: params,
    signal: signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const get_ticket_track = async (success, params, signal) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_ticket_track`, {
    params: params,
    signal: signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const get_checklist_for_assign = async (success, params, signal) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_checklist_for_assign`, {
    params: params,
    signal: signal,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};


export const getCompletedTicketDetails = async (ticket_id, onSuccess, onError) => {
  try {
    const token = await localStorage.getItem("Token");

    const response = await Axios.get(`${bp}/get_completed_ticket_full_details`, {
      params: { ticket_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (onSuccess) onSuccess(response.data);
  } catch (error) {
    console.error("Error fetching completed ticket details:", error);
    if (onError) onError(error);
  }
};

export const get_ticket_timeline = async (ticket_id, onSuccess, onError) => {
  try {
    const token = await localStorage.getItem("Token");

    const response = await Axios.get(`${bp}/get_ticket_timeline`, {
      params: { ticket_id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (onSuccess) onSuccess(response.data);
  } catch (error) {
    console.error("Error fetching completed ticket timeline details:", error);
    if (onError) onError(error);
  }
};
export const get_process_approval_status = async (success, process_id) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_process_approval_status`, {
    params: { process_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("Error fetching process approval status:", error);
    });
};

export const get_operation_detail = async (success, operation_id) => {
  const token = await localStorage.getItem("Token");
  Axios.get(`${bp}/get_operation_detail`, {
    params: { operation_id },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      success(res);
    })
    .catch((error) => {
      console.error("Error fetching operation detail:", error);
    });
};
